<template>
  <div class="mod-sys-user">
    <amis-renderer :schema="schema" />
  </div>
</template>

<script>
import AmisRenderer from '@/components/AmisRenderer';
import schema from './schemas/gen/sys-user.json';

export default {
  name: 'SysUser',
  components: { AmisRenderer },
  data() {
    return {
      schema,
    };
  },
};
</script>

<style lang="scss" scoped></style>
